class OfferExpired {
  constructor (response) {
    this.response = response
  }

  get defaultData () {
    return {
      headline: 'Oferta niedostępna',
      subHeadline: 'Prosimy o kontakt z Biurem Obsługi Klienta',
      mobile: '61 279 74 00',
      helpline: 'Infolinia: PN - PT 09.00 - 19.00   /   SB 10.00 - 14.00',
      validationErrors: [],
    }
  }

  get dataForStatusCode () {
    return {
      400: { headline: 'Wystąpił problem' },
      404: { headline: 'Wybrana oferta <br> nie jest już dostępna' },
      500: { headline: `${this.response.status} - ${this.response.statusText}` },
    }
  }

  get data () {
    return ({
      ...this.defaultData,
      headline: this.dataForStatusCode[this.response.status].headline,
      validationErrors: this.getValidationErrors(),
    })
  }

  getValidationErrors () {
    if (this.response.data && this.response.data.ValidationErrors.length) return this.response.data.ValidationErrors
    else return []
  }
}

export default {
  data () {
    return {
      offerExpiredData: {},
    }
  },
  methods: {
    setOfferExpiredData (response) {
      this.offerExpiredData = new OfferExpired(response).data
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/booking/logic/OfferExpired.js